import "./App.css";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { AuthLayout, Layout } from "./common";
import React, { useEffect, useState } from "react";
import { AppContext } from "./context";
import { setFullStoryIdentity, fetchOrganizationData } from "./common/service";
import { initGA, initMetaPixel } from "./common/analytics";
import { getCurrentUser } from "./auth/service";

const AUTH_ROUTES = [
  "/login",
  "/login_with_otp",
  "/register",
  "/cl",
  "/admin_login",
  "/pricing/682e7cc359d9",
];

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const [catalogs, setCatalogs] = useState({});
  const [projectInfo, setProjectInfo] = useState({});
  const [clearSearch, setClearSearch] = useState(false);
  const [isSubModule, setIsSubModule] = useState(false);
  const [isRemarksOn, setIsRemarksOn] = useState(false);
  const [isExpoOn, setIsExpoOn] = useState(false);
  const [bomSummary, setBomSummary] = useState({ loaded: false });
  const [catalogsLoading, setCatalogsLoading] = useState(false);
  const [organizationData, setOrganizationData] = useState({});
  const [forceRefreshSpaceConfigStatus, setForceRefreshSpaceConfigStatus] =
    useState(false);
  const [orderContext, setOrderContext] = useState([]);
  const [currentUser, setCurrentUser] = useState([]);

  const params = useParams();

  useEffect(() => {
    setFullStoryIdentity();
    initGA();
    initMetaPixel();

    if (location.pathname === "/") {
      const currentUser = getCurrentUser();

      currentUser && !currentUser.isFromLandingPage
        ? navigate("/projects")
        : navigate("/home");
    }

    const currentUser = getCurrentUser();

    if (currentUser) {
      setCurrentUser(currentUser);
      fetchOrganizationData(currentUser.org_id).then((orgData) => {
        setOrganizationData(orgData);
      });
    }
  }, []);

  return (
    <AppContext.Provider
      value={{
        projectInfo,
        setProjectInfo,
        bomSummary,
        setBomSummary,
        catalogs,
        setCatalogs,
        catalogsLoading,
        setCatalogsLoading,
        organizationData,
        setOrganizationData,
        forceRefreshSpaceConfigStatus,
        setForceRefreshSpaceConfigStatus,
        clearSearch,
        setClearSearch,
        isSubModule,
        setIsSubModule,
        isRemarksOn,
        setIsRemarksOn,
        isExpoOn,
        setIsExpoOn,
        orderContext,
        setOrderContext,
        currentUser,
        setCurrentUser,
      }}
    >
      <div className="App">
        {AUTH_ROUTES.some((e) => location.pathname.startsWith(e)) ? (
          <AuthLayout />
        ) : (
          <Layout />
        )}
      </div>
    </AppContext.Provider>
  );
}

export default App;
